export const COMPANY_NAME = "Dixie Property Group Holdings LLC";
export const COMPANY_SHORT = "Dixie Property Group";
export const COMPANY_INITIALS = "DPG";
export const COMPANY_ADDRESS_FULL = "1111 6TH Ave Ste 550, San Diego, CA 92101-5211";
export const COMPANY_LOCATION = "San Diego, CA";
export const COMPANY_REGION = "San Diego County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1111%206TH%20Ave%20Ste%20550%2C%20San%20Diego%2C%20CA%2092101-5211";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Dixie Property Group Holdings LLC" },
  { "label": "Location", "value": "San Diego, CA" },
  { "label": "Region", "value": "San Diego County" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Dixie Property Group Holdings LLC" },
  { "label": "City & state", "value": "San Diego, CA" },
  { "label": "Address", "value": "1111 6TH Ave Ste 550, San Diego, CA 92101-5211" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Directory profile", "body": "A concise public profile built from the organization name and principal-office address provided." },
  { "icon": "✦", "title": "San Diego location", "body": "Based in San Diego, California, with a listed office in the city center." },
  { "icon": "✿", "title": "Public information", "body": "The page keeps its focus on directory-safe organization and location details." },
  { "icon": "❍", "title": "Visit", "body": "Open the address in Maps for directions to the listed office." },
];
